import { type FC } from 'react';

import { LongText } from '../../tailwind';
import { cn } from '../../tailwind/utils';
const MAX_CHARS = 25;

const ProductInfoTitle: FC<{ className?: string; value?: string | null }> = ({
  value,
  className,
}) => {
  if (!value) {
    return null;
  }

  return (
    <LongText
      className={cn(
        'text-sm font-medium leading-none whitespace-nowrap',
        className,
      )}
      maxLength={MAX_CHARS}
      value={value}
    />
  );
};

const ProductInfoSubTitle: FC<{
  className?: string;
  value?: string | null;
}> = ({ value, className }) => {
  return (
    <LongText
      className={cn(
        'text-xs font-medium leading-none whitespace-nowrap text-grey-80 truncate',
        className,
      )}
      value={value}
      maxLength={MAX_CHARS}
    />
  );
};

const ProductInfo = {
  Title: ProductInfoTitle,
  SubTitle: ProductInfoSubTitle,
};

export { ProductInfo };
